import { z } from 'zod';
// =========================================================
// BOM de una colada MANUAL (Fiori) puntual — combina la BOM real de BC
// (`hor.bc-bom.ts` / `L_M_de_ensamblado_Excel`) con cualquier corrección
// local guardada en `hor.colada_bom_override` para ESA colada. La BOM
// maestra en BC nunca se toca desde acá — el override es "solo para este
// pedido puntual".
// =========================================================
export const LineaBomColadaSchema = z.object({
    tipo: z.enum(['item', 'recurso']),
    codigo: z.string(),
    descripcion: z.string(),
    unidad: z.string(),
    /** Cantidad por unidad del producto — la de BC, o la corregida si hay override. */
    cantidad_por_unidad: z.number(),
    /** cantidad_por_unidad * m³ de la colada — lo que se rebajará. */
    cantidad_total: z.number(),
    /** true si este valor viene de un override guardado, no de la BOM de BC. */
    override: z.boolean(),
});
export const ObtenerBomColadaResponseSchema = z.object({
    lineas: z.array(LineaBomColadaSchema),
    m3_producidos: z.number(),
    /** false si la colada aún no tiene producto BC mapeado (lineas viene vacío). */
    producto_mapeado: z.boolean(),
});
export const GuardarBomOverrideRequestSchema = z.object({
    cantidad_por_unidad: z.number().nonnegative(),
});
//# sourceMappingURL=colada-bom.js.map